import { render, staticRenderFns } from "./LoginBg.vue?vue&type=template&id=89c430be&scoped=true&"
import script from "./LoginBg.vue?vue&type=script&lang=js&"
export * from "./LoginBg.vue?vue&type=script&lang=js&"
import style0 from "./LoginBg.vue?vue&type=style&index=0&id=89c430be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c430be",
  null
  
)

export default component.exports